var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.window.is.mobile)?_c('core-filter-input-text',{staticClass:"filter-text-wrapper",attrs:{"filter":_vm.filter,"placeholder":"Quick search..."},on:{"ready":_vm.onReady}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }